var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.error && _vm.error.status >= 500)?_c('div',{staticClass:"alert error",domProps:{"innerHTML":_vm._s(_vm.$t('filters.error500') + _vm.$t('contactUs'))}}):(_vm.error)?_c('div',{staticClass:"alert warning"},[_vm._v(_vm._s(_vm.$t('filters.error400')))]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }